import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, contentChild, input, TemplateRef } from '@angular/core';
import { AbstractControl, FormArray } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormArrayControlFactory, FormArrayItemContext } from './form-array.model';

@Component({
    selector: 'tran-form-array',
    imports: [NgTemplateOutlet, TranslateModule],
    templateUrl: './form-array.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormArrayComponent<TControl extends AbstractControl> {
    public readonly control = input.required<FormArray<TControl>>();
    public readonly createControl = input.required<FormArrayControlFactory<TControl>>();
    public readonly addLabel = input.required<string>();
    public readonly removeLabel = input.required<string>();
    public readonly minItems = input(0);
    public readonly maxItems = input<number | undefined>(undefined);

    protected readonly itemTemplate = contentChild.required<TemplateRef<FormArrayItemContext<TControl>>>(TemplateRef);

    protected addItem(): void {
        const control = this.control();

        control.push(this.createControl()(control.length));
        control.markAsDirty();
        control.markAsTouched();
    }

    protected removeItem(index: number): void {
        if (!this.canRemove()) {
            return;
        }

        const control = this.control();

        control.removeAt(index);
        control.markAsDirty();
        control.markAsTouched();
    }

    protected canAdd(): boolean {
        const maxItems = this.maxItems();
        return !this.control().disabled && (maxItems === undefined || this.control().length < maxItems);
    }

    protected canRemove(): boolean {
        return !this.control().disabled && this.control().length > this.minItems();
    }
}
